import { render, staticRenderFns } from "./detectionData.vue?vue&type=template&id=5d7c7a10&scoped=true"
import script from "./detectionData.vue?vue&type=script&lang=js"
export * from "./detectionData.vue?vue&type=script&lang=js"
import style0 from "./detectionData.vue?vue&type=style&index=0&id=5d7c7a10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7c7a10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7c7a10')) {
      api.createRecord('5d7c7a10', component.options)
    } else {
      api.reload('5d7c7a10', component.options)
    }
    module.hot.accept("./detectionData.vue?vue&type=template&id=5d7c7a10&scoped=true", function () {
      api.rerender('5d7c7a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/components/detectionData.vue"
export default component.exports